__webpack_require__.p = "/reports-optimization/referrals-hub/";